import {TemplateItem} from '../types/templateStructure';

export function getUpdatedItemFromElement(
    item: TemplateItem,
    targetElement: HTMLElement
): TemplateItem | null {
    const paramIndexAttr = targetElement.getAttribute('data-param-index');
    
    if(paramIndexAttr !== null && item.type === 'inline' && item.params) {
        // Update specific param in inline item
        const paramIndex = parseInt(paramIndexAttr, 10);
        if(isNaN(paramIndex)) return null;
        
        const updatedParams = item.params.map(p => 
            p.index === paramIndex 
                ? {...p, value: targetElement.innerHTML}
                : p
        );
        
        return {
            ...item,
            params: updatedParams
        };
    } else if(item.type === 'text') {
        // Update text item directly
        return {
            ...item,
            value: targetElement.innerHTML || ''
        };
    }
    
    return null;
}